export default "__VITE_ASSET__BWViv2RS__"